/**
 * Die Versionszeile in den Karten „Browser-Erweiterung“ und „Vespera
 * Desktop“. (29.09.2026, Ticket 2816)
 *
 * Eine ruhige Zeile „Bei dir: 2.0.5 · Aktuell: 2.0.6“ und — nur wenn es
 * etwas zu tun gibt — ein Satz darunter. Die Sätze selbst entstehen in
 * shared/app-version.ts, hier wird nur gezeichnet. Aussehen: style.css
 * `.connector-version` (keine Inline-Styles).
 */
import type { UpdateStand } from "../../shared/app-version.js";

/** Legt die Zeile an bzw. aktualisiert sie; gibt das Element zurück. */
export function versionZeile(vorhanden: HTMLElement | null, stand: UpdateStand): HTMLElement {
  const el = vorhanden ?? document.createElement("div");
  el.className = "connector-version";
  el.dataset.art = stand.art;
  while (el.firstChild) el.removeChild(el.firstChild);

  const zeile = document.createElement("span");
  zeile.className = "connector-version-zeile";
  zeile.textContent = stand.zeile;
  el.appendChild(zeile);

  if (stand.hinweis) {
    const hinweis = document.createElement("p");
    hinweis.className = "connector-version-hinweis";
    hinweis.textContent = stand.hinweis;
    el.appendChild(hinweis);
  }
  return el;
}
